export default "__VITE_ASSET__Dvr6pi8I__"